import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useUserApiTokens = (userId, config) => {
  return useQuery({
    ...config,
    queryKey: ["api-tokens"],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/users/${userId}/api-tokens`,
        signal,
      });
    },
  });
};

export const useDeleteApiToken = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, tokenId }) =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/api-subscriptions/${tokenId}`,
        method: "DELETE",
      }),
    onSuccess: () => {
      client.invalidateQueries(["api-tokens"]);
      client.invalidateQueries(["integrations"]);
    },
  });
};

export const useApiToken = (userId, tokenId, config) => {
  return useQuery({
    ...config,
    queryKey: ["api-subscription", tokenId],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/api-subscriptions/${tokenId}`,
        signal,
      }),
  });
};

export const useUpdateApiToken = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, tokenId, data }) =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/api-subscriptions/${tokenId}`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries(["api-tokens"]);
      client.invalidateQueries(["integrations", "mcp"]);
    },
  });
};

export const useAddApiToken = () => {
  return useMutation({
    mutationFn: (payload) =>
      fetch({
        url: `${Angie.api_url}/users/${payload.userId}/api-subscriptions`,
        method: "POST",
        body: payload.data,
      }),
  });
};
